import { useState } from "react";
import ConfirmModal from "./ConfirmModal";

const DeleteButton = ({
    handleDelete,
    confirmTitle = "Delete this item?",
    confirmMessage = "This action cannot be undone.",
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const buttonClassName =
        "delete-button px-3 py-1 border-2 rounded-lg transition-colors duration-300 bg-red-100 text-red-600 hover:bg-red-600 hover:text-white";

    return (
        <>
            <div>
                <button
                    type="button"
                    onClick={() => setIsModalOpen(true)}
                    className={buttonClassName}
                >
                    Delete
                </button>
            </div>
            <ConfirmModal
                isOpen={isModalOpen}
                title={confirmTitle}
                message={confirmMessage}
                onConfirm={() => {
                    setIsModalOpen(false);
                    handleDelete();
                }}
                onCancel={() => setIsModalOpen(false)}
            />
        </>
    );
};

export default DeleteButton;
